$(function () {

    $(document).ready(function () {
        $(document).click(function (e) {
            var el;

            if ($(e.target).parent().hasClass('fa-plus') || $(e.target).hasClass('fa-plus')) {

                if ($(e.target).hasClass('fa-plus')) {
                    el = $(e.target);
                }
                else {
                    el = $(e.target).parent();
                }

                el.hide();

                el.siblings('.fa-minus').show();

                el.parents('.category').find('.sub-categories').slideDown();
            }
            else if ($(e.target).parent().hasClass('fa-minus') || $(e.target).hasClass('fa-minus')) {

                if ($(e.target).hasClass('fa-minus')) {
                    el = $(e.target);
                }
                else {
                    el = $(e.target).parent();
                }

                el.hide();

                el.siblings('.fa-plus').show();

                el.parents('.category').find('.sub-categories').slideUp();
            }
        });
    });
});